/**
 @ngdoc service
 @name mapScreeningcandidateTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningcandidateTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));
            tileFactory.addFieldToColumn1(tileFactory.field.newInactiveFieldAjax('mobile', 'mobileOptout', 'mobileOptout',null,'logPhoneCall'));
            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('town'));
            tileFactory.addFieldToColumn3(tileFactory.field.newFieldBooleanYesOrNo('eligibilityToWork'));
            tileFactory.addFieldToColumn3({label: objectTilesLabels.highestLevelOfEducation.label, value: rawTileData.highestLevelOfEducationText});
            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastUpdated', 'dateTime'));
            // tileFactory.addFieldToFullWidthRow(tileFactory.field.newField('email'));
            tileFactory.addFieldToFullWidthRow(tileFactory.field.newWarningField('email', ['invalidEmailWarning', 'spamEmailWarning']));

                       if(rawTileData.emailPermission==true) {
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidEmailStatus', 'invalidEmailWarning'));
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidSpamStatus', 'spamEmailWarning'));
            }
            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapScreeningcandidateTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningcandidateTileService', mapScreeningcandidateTileService);
}());
